module.exports = __webpack_public_path__ + "img/numcap.b85a6020.png";